// extracted by mini-css-extract-plugin
module.exports = {"Component":"Footer_Component__2PMBl","Row":"Footer_Row__rBuGB","Copyright":"Footer_Copyright__21NUm","Nav":"Footer_Nav__3sOaa","Payments":"Footer_Payments__1Xo56"};